var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-year-timer"},[_c('span',{staticClass:"timer-item"},[_vm._v(_vm._s(_vm.timeLeft.day))]),_c('span',{staticClass:"timer-item"},[_vm._v(_vm._s(_vm.timeLeft.hour))]),_c('span',{staticClass:"timer-item"},[_vm._v(_vm._s(_vm.timeLeft.minutes))]),_c('span',{staticClass:"timer-item"},[_vm._v(_vm._s(_vm.timeLeft.seconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }